import React from 'react';
import styled from 'styled-components';
import { array, number, func, bool, oneOfType, object } from 'prop-types';
import MediaQuery from 'react-responsive';

import withVisibilityToggle from '../../core/enhancements/withVisibilityToggle';
import withToggle from '../../core/enhancements/withToggle';
import Characteristic from './Characteristic';

const icons = {
  arrowDown: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOCAYAAAArMezNAAAAAXNSR0IArs4c6QAAAcFJREFUOBG1kjlLA1EQx2c22cQoYqNfQQQPFOw06MYo2FlZxAssbO2EKMKiJGCh2AoBUSFeIKQSZGMwiFhYaBG1E8FCRTyKmGRzPGc2bJCIF8bXzHsz8//NsQvwTwdNrncrWiMldJdvxL1p+n5j1WCkWtczO2iFCd9g97HEYjUSKcPXZDQHYn1yRRv8DdDQMzSdCQsQzlxWLLIvD1aUJN0CIARNIJa9a1rfT+FGpwwVogkRL+wO2dAaYIb4h3vmJZBmKMEK2dzG5JrW/R28GAoyKmq/csu6wo5NCK1iUYjcOEXikmTp8Q11HZmx95ahKT2zTxM2cqcM9Xvcd2bOBzB1jFOrWoDsKNV9Qdna6R9QTk0BW/7Q8JoKG1DAc7Ch6z2Ucwqr4Acfqi6aHe4xRNgmYRWk03veYKQuH81DMZHMd/oJ1OCYgmK7dHIiX8ceQ0JAL63lxm6TnSmLJc5Q8jUgQW1SuaIOt90Xa78Ec3Bh68jxkIjv0lo6aJIr+mtSAqCOCsXsWOH6DPotmBPmQoeVz0+JA1pLiyFAuLRhRcdX0B+BOUld0Wp1EGd8t8iO1llPe4zvJTnTwcN6LlAS2F8gbzKqvdaeKZqfAAAAAElFTkSuQmCC',
  arrowUp: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOCAYAAAArMezNAAAAAXNSR0IArs4c6QAAAadJREFUOBHF0s8vA0EUB/D3dm21whV/gfhxcXASIa2ScHMgWmmEuBNuFcmGaOPCmZuGJhoS4ka1B+XUQ/1o0hsSN41ogk1b+rxpssK2qw4Sm2wmM/vmk++bHYD/fhaCsTZ1M9z02xz4m0IB5oAuRK2s2DqW3F3JSvukSgUrB7G6HNEOEVnF+55/3VUDZ/WV9v0Ir4bObZkn7ZCA2hHxhttLEUFzll4ilXBTeD0eV9La8x6n7AGEe4ulykE11m5EuAaCtlzhNfoTXhYOhUi+Sz5uc7oBTvkAitKnuuy3/pHuB7JZHQLnLloF7g2GG8odSwnMCTGhhTcYHQbADKP9frc9pW/Wcf52JXDIUaQcXgLPB07WGJ/k9l8kWRr0jdkTOqqPAq/mo/nE81SS/Bvs3TxaJCpMM5BFSRpa9vSe65hxVN32tMD5p15ykBYw4J+wN3A0x+0vcOEbyNKoz+M8NmLGucAtSlXvV1wNRRtFXREW1woKMAWIxO1N+D3OfSNiNjfiWS1f3FuEZ0c6NXGVJECXb9y5ZYaYrQu8FtCBgKeSjDNmdX+y/gFE6sJEBb3edQAAAABJRU5ErkJggg==',
};

const Container = styled.div`
  border-top: solid 1px #E1E1E1;
  margin: 25px 20px 0;
  position: relative;
`;

const Toggler = styled.div`
  color: #9027b0;
  font-weight: bold;
  font-size: 14px;
  margin-top: 20px;
  &::after {
    background-repeat: no-repeat;
    content: '';
    display: inline-block;
    margin-left: 5px;
    background-size: 10px 6px;
    height: 7px;
    width: 10px;
    background-image: url(${({ toggled }) => ((toggled) ? icons.arrowUp : icons.arrowDown)});
  }
`;

const ItemsContainer = styled.aside`
  text-align: left;
`;

const ToggableItems = withVisibilityToggle(ItemsContainer);

const Characteristics = ({
  characteristics, price, amount, toggle, toggled, openModal, referencePrice,
}) => (
  <Container>
    {/* Desktop */}
    <MediaQuery minDeviceWidth={1000}>
      {characteristics.map(characteristic =>
        (<Characteristic
          key={btoa(characteristic.text)}
          price={price}
          amount={amount}
          characteristic={characteristic}
          openModal={openModal}
          referencePrice={referencePrice}
        />))}
    </MediaQuery>

    {/* Mobile */}
    <MediaQuery maxDeviceWidth={1000}>
      <Toggler toggled={toggled} onClick={toggle}>Veja os benefícios</Toggler>
      <ToggableItems showIf={toggled} toggled={toggled}>
        {characteristics.map(characteristic =>
          (<Characteristic
            key={btoa(characteristic.text)}
            price={price}
            amount={amount}
            characteristic={characteristic}
            openModal={openModal}
            referencePrice={referencePrice}
          />))}
      </ToggableItems>
    </MediaQuery>
  </Container>
);

Characteristics.propTypes = {
  characteristics: array.isRequired,
  price: oneOfType([number, object]).isRequired,
  amount: number.isRequired,
  toggle: func.isRequired,
  toggled: bool.isRequired,
  openModal: func.isRequired,
  referencePrice: number,
};

Characteristics.defaultProps = {
  referencePrice: 0.00,
};

export default withToggle(Characteristics);
